export default "__VITE_ASSET__XINh4cDf__"